import { Controller } from "@hotwired/stimulus"

// Counts the average up when it changes and grows the distribution bars on
// reveal. Remembers the last value per room so polling re-renders stay still.
const memory = {}

export default class extends Controller {
  static targets = ["average", "bar"]
  static values = { roomId: String, average: String, revealed: Boolean }

  connect() {
    const previous = memory[this.roomIdValue] || {}
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    if (this.revealedValue && !previous.revealed && !reduced) {
      this.barTargets.forEach(bar => bar.classList.add("grow"))
    }

    const target = parseFloat(this.averageValue)
    if (!Number.isNaN(target) && this.averageValue !== previous.average && !reduced) {
      this.countUp(Number.isNaN(parseFloat(previous.average)) ? 0 : parseFloat(previous.average), target)
    }

    memory[this.roomIdValue] = { average: this.averageValue, revealed: this.revealedValue }
  }

  countUp(from, to, duration = 600) {
    const element = this.averageTarget
    const start = performance.now()
    const step = now => {
      const progress = Math.min(1, (now - start) / duration)
      const eased = 1 - Math.pow(1 - progress, 3)
      element.textContent = (from + (to - from) * eased).toFixed(1)
      if (progress < 1) requestAnimationFrame(step)
      else element.textContent = to.toFixed(1)
    }
    requestAnimationFrame(step)
  }
}
